<template>
  <SiteContent>
    <div>Content</div>
  </SiteContent>
  <CookieConsent />
</template>

<script>
import { reactive, onMounted } from 'vue';
import SiteContent from './components/layout/SiteContent.vue';
import CookieConsent from './components/CookieConsent.vue';
import { useSEO } from './composables/useSEO';
import { useCustomCursor } from './composables/useCustomCursor';

export default {
  name: 'App',
  components: {
    SiteContent,
    CookieConsent
  },
  setup() {
    const { setPageMeta } = useSEO();
    useCustomCursor();

    const siteData = reactive({
      title: `Ileana Sofronie | Product designer in Köln`,
      description: `Accomplished product designer with a focus on innovation, aesthetics, and user-centricity. Crafting fully functional digital products that leave an indelible mark.`,
      keywords: `product designer, innovation, aesthetics, user-centric design, digital products, collaboration, human-centered approach, exceptional products, design experiences, Köln, Germany`,
    });

    // Set default meta tags
    setPageMeta({
      title: siteData.title,
      description: siteData.description,
      keywords: siteData.keywords,
      image: '/images/og-image.png',
      type: 'website'
    });

    // Add smooth scroll behavior
    onMounted(() => {
      document.documentElement.style.scrollBehavior = 'smooth';
    });
  }
}
</script>

<style lang="scss">
  // Hide default cursor on desktop
  @media (min-width: 1024px) {
    * {
      cursor: none !important;
    }
  }

  // Custom cursor styles
  .custom-cursor-dot {
    position: fixed;
    top: 0;
    left: 0;
    width: 8px;
    height: 8px;
    background-color: var(--color-black);
    border-radius: 50%;
    pointer-events: none;
    z-index: 10000;
    opacity: 0;
    transform: translate(-50%, -50%);
    transition: opacity 0.3s ease;
  }

  .custom-cursor-outline {
    position: fixed;
    top: 0;
    left: 0;
    width: 40px;
    height: 40px;
    border: 2px solid var(--color-black);
    border-radius: 50%;
    pointer-events: none;
    z-index: 9999;
    opacity: 0;
    transform: translate(-50%, -50%);
    transition: opacity 0.3s ease, transform 0.3s ease;
  }

  // Route transition overlay styles (animated by GSAP in router.js)
  .route-transition-overlay {
    will-change: transform;
  }

</style>